const getQueryParam = (queryName, queryPath) => {
  queryName = queryName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]"); // eslint-disable-line
  const regex = new RegExp("[\\?&]" + queryName + "=([^&#]*)"),
  results = regex.exec(queryPath);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

module.exports = getQueryParam;
